export default "__VITE_PUBLIC_ASSET__ea665c53__"